export default {
  state: {
    // webstore cart
    CART: [],
  },
  mutations: {
    // get CART on refresh from localStorage
    initialiseCART(state) {
      if (
        localStorage.getItem("CART") !== undefined &&
        localStorage.getItem("CART") !== null
      ) {
        state.CART = JSON.parse(localStorage.getItem("CART"));
      }
    },
    // set Cart content
    storeCART: function (state, mutation) {
      // write to the state
      state.CART.push(mutation);
      // write to localStorage
      localStorage.setItem("CART", JSON.stringify(state.CART));
    },
    // clear cart content
    clearCART: function (state) {
      state.CART = [];
      localStorage.setItem("CART", JSON.stringify([]));
    },
    // edit content of cart
    contentCART: function (state, mutation) {
      state.CART[mutation.key] = mutation.value;
      localStorage.setItem("CART", JSON.stringify(state.CART));
    },
    // remove item from cart
    removeItemCART: function (state, mutation) {
      state.CART.splice(mutation, 1);
      localStorage.setItem("CART", JSON.stringify(state.CART));
    },
  },
  actions: {},
  modules: {},
  getters: {
    // get Cart content
    getCART: (state) => {
      return state.CART;
    },
  },
};
